module.exports = __webpack_public_path__ + "static/media/xfactor.c2385ab2.jpg";